import { render, staticRenderFns } from "./WebViewer.vue?vue&type=template&id=4b5568b0&scoped=true"
import script from "./WebViewer.vue?vue&type=script&lang=js"
export * from "./WebViewer.vue?vue&type=script&lang=js"
import style0 from "./WebViewer.vue?vue&type=style&index=0&id=4b5568b0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b5568b0",
  null
  
)

export default component.exports